"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EffectAppliedEventArgs = void 0;
const EventType_1 = require("../EventType");
class EffectAppliedEventArgs {
    constructor(effectId) {
        this.effectId = effectId;
        this.__type = EventType_1.EventType.EffectApplied;
        this.__typeName = "EffectApplied";
    }
}
exports.EffectAppliedEventArgs = EffectAppliedEventArgs;
